// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1OirK","container":"styles_container__3vBDw","title":"styles_title__7Gdcz","wrapper":"styles_wrapper__2m6HF","answer":"styles_answer__2e0q4"};